import { useState } from "react";

import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from "react-accessible-accordion";

import { ROUTES } from "@/helpers/routes";
import Layout from "@/shared/components/layout";
import PageSeo from "@/shared/components/PageSeo";

interface IFaqData {
    title: string;
    description: string;
}
const faqData: IFaqData[] = [
    {
        title: "What is The Gender Index? ",
        description: `<p>The Gender Index is the largest ever study into female entrepreneurship in the UK.<p>
        <p>Using a combination of dynamic data and technology, The Gender Index was conceived to establish a benchmark of the current level of activity of companies across the UK,
         from large to SMEs to start-up, which are owned or led by female founders.</p>
        <p>The live data is constantly refreshed and draws from 5.2 million* active companies. It covers gender, regions, sectors, investment and other valuable insights.</p>                
        <br />`,
    },
    {
        title: "Where does the The Gender Index data come from?",
        description: `<p>The data comes from mnAI, a UK data platform provider that uses machine learning algorithms to provide unique in-depth insights regarding
         every aspect of the makeup of UK companies.</p>
         <p>The data that makes up The Gender Index uses a combination of machine learning algorithms and data generated from public and private sources, and mnAi is a single source of
          unified data holding 12 billion data points across over 11 million UK companies, of which 5.2 million* are active.</p>     
        <br />`,
    },
    {
        title: "Why have you only included male and female as genders?",
        description: `<p>Due to current data protection legislation, we simply cannot gain access to information on further gender categories, including non-binary and gender fluid in this area.</p>
         <p>We do hope this changes in the future, and we are able to offer insights across all recognised UK gender types.</p>     
        <br />`,
    },
];
export default function Faq() {
    const [selectedItem, setSelectedItem] = useState<number[]>([]);
    return (
        <Layout>
            <PageSeo title="Frequently Asked Questions | The Gender Index" pathname={ROUTES.faq} />
            <div className='singleLayout privacyPage faq-accordion'>
                <h3>The Gender Index FAQ</h3>
                <Accordion
                    className="custom-accordion"
                    allowMultipleExpanded
                    preExpanded={[0]}>
                    {
                        faqData.map((item, index) => (
                            <AccordionItem
                                key={index}
                                onClick={() => {
                                    setSelectedItem(p => {
                                        if (p.includes(index)) {
                                            return p.filter(i => i !== index);
                                        }
                                        return [...p, index];
                                    });
                                }}>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        <div className="accordion_title">
                                            {item.title}
                                        </div>
                                        <div className="accordion__state">
                                            {
                                                selectedItem.includes(index)
                                                    ? <FontAwesomeIcon icon={faMinus} />
                                                    : <FontAwesomeIcon icon={faPlus} />
                                            }
                                        </div>
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    <div dangerouslySetInnerHTML={{ __html: item.description }} />
                                </AccordionItemPanel>
                            </AccordionItem>
                        ))
                    }
                </Accordion>
            </div>
        </Layout>
    );
}
